import { StyleSheet, css } from 'aphrodite';
import { accentGray } from '../colors';

export { css };
export default StyleSheet.create({
  cellDisabled: {
    color: accentGray,
  },
});
